import React from 'react';

const ProfilesContext = React.createContext({});

export const ProfilesContextProvider = ProfilesContext.Provider;
export const ProfilesContextConsumer = ProfilesContext.Consumer;

export default ProfilesContext;
